const SHELL_STATIC_SEGMENTS = new Set(["new", "stocks"]);

/** Replace app-owned dynamic route identifiers before Faro sees page metadata. */
export function sanitizeClientTracePathname(pathname: string): string {
  const normalizedPathname =
    pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const segments = normalizedPathname.split("/");

  if (
    segments.length === 5 &&
    segments[1] === "app" &&
    segments[2] === "shell" &&
    segments[3] === "stocks" &&
    segments[4]
  ) {
    return "/app/shell/stocks/[stock_symbol]";
  }
  if (
    segments.length === 4 &&
    segments[1] === "app" &&
    segments[2] === "shell" &&
    segments[3] &&
    !SHELL_STATIC_SEGMENTS.has(segments[3])
  ) {
    return "/app/shell/[thread]";
  }
  if (segments.length === 3 && segments[1] === "share" && segments[2]) {
    return "/share/[thread]";
  }

  return normalizedPathname;
}
